import { render, staticRenderFns } from "./RolesManager.vue?vue&type=template&id=253f2b93&scoped=true"
import script from "./RolesManager.vue?vue&type=script&lang=js"
export * from "./RolesManager.vue?vue&type=script&lang=js"
import style0 from "./RolesManager.vue?vue&type=style&index=0&id=253f2b93&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "253f2b93",
  null
  
)

export default component.exports